import services from './services';
import { message } from 'antd';
import { setLanguageBundle } from '@nackle/intl-tools';
import { getUser } from './services/id-service';
import { getPeople, searchPeople } from './services/roster-service';

export const apiGetBundles = async ( bundleNames, locale ) => {
    try {
        const bundles = await Promise.all( bundleNames.map( async bundleName => 
            await services.cmx.getBundle( bundleName, [ locale ] )
        ) );
        let combinedBundle = {};
        bundles.map( bundle => combinedBundle = { ...combinedBundle, ...bundle.bundles[ locale ] } );
        await setLanguageBundle( locale, combinedBundle );
        return bundles;
    } catch ( error ) {
        console.alert( 'apiGetBundles failed' );
        message.error( `An error occurred: ${ error }` );
        throw new Error( error );
    }
};

export const apiGetAllCompanies = async ( ) => {
    try {
        const companies = await services.companyService.getCompanies();
        return companies.companyList;
    } catch ( error ) {
        console.error( 'apiGetAllCompanies failed' );
        message.error( `an error occurred: ${ error }` );
        throw new Error( error );
    }
};

export const apiGetUser = async ( ) => {
    try {
        const response = await getUser();
        return response;
    } catch ( error ) {
        console.error( 'apiGetUser failed' );
        message.error ( `An error occurred: ${ error }` );
        throw new Error( error );
    }
};

export const apiGetPeople = async ( companyId ) => {
    try {
        const response = await getPeople( companyId );
        return response;
    } catch ( error ) {
        console.error( 'apiGetPeople failed' );
        message.error( `An error occurred: ${ error }` );
    }
};

export const apiSearchPeople = async ( searchText, companyId ) => {
    try {
        const response = await searchPeople( searchText, companyId );
        return response;
    } catch ( error ) {
        console.error( 'apiSearchPeople failed' );
        message.error( `An error occurred: ${ error }` );
    }
};

export const apiGetLocales = async () => {
    try {
        const response = await services.cmx.getAllLocales();

        const locales = response?.locales?.filter( l => l.standardLocale )
            .map( locale => {
                return {
                    value: locale.code,
                    label: `${ locale.label_enUS } - ${ locale.label }`
                };
            } ).sort( ( a, b ) => a.label.localeCompare( b.label ) );
        return locales || [];
    } catch ( error ) {
        console.error( 'apiGetLocales failed', error );
        message.error( `An error occurred: ${ error }` );
    }
};